import React from 'react';
import { connect } from 'react-redux';
import Spinner from 'src/ui/library/Spinner/Spinner';
import ProgressStatusPres from '../Presentation/ProgressStatusPres';
import NotesPres from '../Presentation/NotesPres';
import { getCaseStatusInfo } from 'src/services/dashboard.service';

class ProgressNotesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caseStatusInfo: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    let caseId = this.props.caseId;
    if (caseId) {
      this.setState({ caseStatusInfo: {}, isLoading: true });
      getCaseStatusInfo(caseId).then(resp => {
        this.setState({ caseStatusInfo: resp, isLoading: false });
      });
    }
  }

  render() {
    const { caseStatusInfo, isLoading } = this.state;
    return (
      <React.Fragment>
        {isLoading ? (
          <Spinner size={30} />
        ) : (
          <div>
            <ProgressStatusPres milestones={caseStatusInfo.milestones} />
            <NotesPres caseReportNote={caseStatusInfo.caseReportNote} />
          </div>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ProgressNotesContainer);
